import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AudioProvider } from './audio/AudioProvider';
import { SupernaturalProvider } from './atmosphere';
// Foundation tokens（Phase D）: mood ごとの CSS variables と共通スケール。
// 消費ルールは [data-mood] スコープなので、theme 未指定時は style.css に影響しない。
import './minigames/foundation/tokens/colors.css';
import './minigames/foundation/tokens/typography.css';
import './minigames/foundation/tokens/motion.css';
import './minigames/foundation/tokens/spacing.css';
// シェル mood トークン層（NR3 で style.css 冒頭から分離。定義は :root / html[data-mood] のみなので style.css より前に読み込んでも見た目は不変）。
import './styles/shell-tokens.css';
import './style.css';

const rootElement = document.getElementById('app');

if (!rootElement) {
  throw new Error('#app element not found');
}

// dev 専用: `?gallery=1` で Foundation Gallery を起動する（Phase D §4.3）。
// import.meta.env.DEV ガード＋動的 import なので production ビルドでは dead code
// として除外される（dist に FOUNDATION_GALLERY_DEV_ONLY が残らないことで検証）。
// 全描画経路を AudioProvider で覆う（R2 感覚層・Wave2A）。
// これにより初回ジェスチャでの audioEngine.unlock() が本番/dev/sandbox/gallery のどこでも
// 普遍的に成立し、ミニゲーム側 useMinigameSound の unlock も併せて立ち上がる。
// さらに SupernaturalProvider で覆う（P2「端末は付喪神」Wave B・気配/超常演出の基盤）。
// AudioProvider の内側にネストし、全経路（本番/dev/sandbox/gallery）で useSupernatural が成立する。
if (import.meta.env.DEV && new URLSearchParams(location.search).has('gallery')) {
  void import('./foundation-gallery/FoundationGallery').then(({ FoundationGallery }) => {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <AudioProvider>
          <SupernaturalProvider>
            <FoundationGallery />
          </SupernaturalProvider>
        </AudioProvider>
      </React.StrictMode>
    );
  });
} else if (import.meta.env.DEV && new URLSearchParams(location.search).has('sandbox')) {
  // dev 専用: `?sandbox=1&template=NN&mood=X` で単一ミニゲームを standalone マウント（Phase E4）。
  // gallery 同様、import.meta.env.DEV ガード＋動的 import で production からは dead code 除外。
  void import('./minigame-sandbox/MinigameSandbox').then(({ MinigameSandbox }) => {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <AudioProvider>
          <SupernaturalProvider>
            <MinigameSandbox />
          </SupernaturalProvider>
        </AudioProvider>
      </React.StrictMode>
    );
  });
} else {
  // 2026-07-20 傷②: root ErrorBoundary。描画中の未捕捉例外で React ツリーごと
  // アンマウントされて無言の白画面になる事故を、シェルの声の fallback（読み直し導線付き）で受ける。
  // Provider 層（Audio/Supernatural）の描画例外も受けられるよう最外殻に置く。
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ErrorBoundary>
        <AudioProvider>
          <SupernaturalProvider>
            <App />
          </SupernaturalProvider>
        </AudioProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
}



